<div class="torzsadat-page">
  <!-- Kategória-szűrő jelző -->
  <div class="torzsadat-filter-row" *ngIf="menuKategoria">
    <div class="torzsadat-filter-col">
      <ion-chip color="primary" style="margin-bottom: 4px">
        <ion-icon name="filter-outline"></ion-icon>
        <ion-label>Szűrő: {{ menuKategoriaLabel }}</ion-label>
        <ion-icon name="close-circle" *ngIf="false"></ion-icon>
      </ion-chip>
    </div>
  </div>
  <div class="torzsadat-content-row">
    <!-- ═══ BAL PANEL: tábla-lista ═══════════════════════════════════════════ -->
    <div class="torzsadat-side-panel" *ngIf="!tableMode">
      <ion-card style="height:100%">
        <ion-card-header>
          <ion-card-title>Törzsadat-táblák</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <ion-button expand="block" color="primary" (click)="openAddMeta()">
            <ion-icon slot="start" name="add-circle-outline"></ion-icon>
            Tábla hozzáadása
          </ion-button>

          <ion-list lines="full" style="margin-top:8px">
            <ion-item *ngFor="let t of tablaMeta"
                      [color]="activeMeta?.id === t.id ? 'primary' : ''"
                      button detail="false"
                      (click)="selectTable(t)">
              <ion-label>
                <h2>{{ t.display_name }}</h2>
                <p><code>{{ t.table_name }}</code></p>
              </ion-label>
              <ion-buttons slot="end">
                <ion-button fill="clear" (click)="$event.stopPropagation(); openEditMeta(t)"
                            [color]="activeMeta?.id === t.id ? 'light' : 'medium'">
                  <ion-icon name="create-outline" slot="icon-only"></ion-icon>
                </ion-button>
                <ion-button fill="clear" (click)="$event.stopPropagation(); deleteMeta(t)" color="danger">
                  <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-item>
          </ion-list>

          <div *ngIf="tablaMeta.length === 0" class="ion-text-center ion-padding" style="color: var(--ion-color-medium)">
            <ion-icon name="list-outline" style="font-size:32px"></ion-icon>
            <p>Még nincs hozzáadott tábla.</p>
          </div>
        </ion-card-content>
      </ion-card>
    </div>

    <!-- ═══ JOB PANEL: adat-grid ══════════════════════════════════════════════ -->
    <div class="torzsadat-main-panel" [class.torzsadat-main-full]="tableMode">
      <div *ngIf="!activeMeta" class="ion-text-center ion-padding" style="margin-top: 80px; color: var(--ion-color-medium)">
        <ion-icon name="grid-outline" style="font-size: 64px"></ion-icon>
        <h2>Válassz táblát a bal oldalon!</h2>
      </div>

      <ng-container *ngIf="activeMeta">
        <!-- Eszköztár -->
        <div style="margin-top: 10px; margin-bottom: 8px">
          <strong *ngIf="tableMode" style="font-size: 1.15em; margin-right: 16px">{{ activeMeta.display_name }}</strong>
          <ion-button color="primary" (click)="openAddRow()">
            <ion-icon slot="start" name="add"></ion-icon>
            Új sor
          </ion-button>
          <ion-button color="secondary" [disabled]="selected.length !== 1" (click)="openEditRow()">
            <ion-icon slot="start" name="create"></ion-icon>
            Módosítás
          </ion-button>
          <ion-button color="danger" [disabled]="selected.length === 0" (click)="deleteRow()">
            <ion-icon slot="start" name="trash"></ion-icon>
            Törlés
          </ion-button>
          <ion-button color="light" (click)="loadRows()">
            <ion-icon slot="start" name="refresh"></ion-icon>
            Frissítés
          </ion-button>
          <span style="margin-left: 12px; color: var(--ion-color-medium); font-size: 0.9em">
            Összesen: {{ total }} sor
          </span>
        </div>

        <!-- Kereső + oldalméret -->
        <div style="display:flex; align-items:center; gap:12px; margin-bottom:8px; flex-wrap:wrap">
          <input
            type="text"
            class="form-control"
            placeholder="Keresés minden mezőben…"
            style="flex:1; min-width:180px; max-width:340px"
            [value]="filterText"
            (input)="updateFilter($any($event.target).value)"
          />
          <label style="font-size:0.9em; white-space:nowrap">
            Oldalméret:
            <select (change)="onLimitChange($event)" style="margin-left:4px">
              <option *ngFor="let opt of pageLimitOptions" [value]="opt.value" [selected]="opt.value === currentPageLimit">
                {{opt.value}}
              </option>
            </select>
          </label>
        </div>

        <!-- Adat-táblázat -->
        <div class="torzsadat-table-shell">
          <ngx-datatable
            #table
            class="ngx-datatable cronomitnew torzsadat-table fixed-header fixed-row scroll-horz selectable checkbox-selection"
            [rows]="filteredRows"
            [columnMode]="ColumnMode.standard"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="38"
            [limit]="currentPageLimit"
            [count]="filteredRows?.length || 0"
            [scrollbarH]="true"
            [selected]="selected"
            [selectionType]="SelectionType.checkbox"
            (select)="onSelect($event)"
            [loadingIndicator]="loading"
            [messages]="{ emptyMessage: 'Nincs megjeleníthető adat!', totalMessage: 'sor' }">

            <!-- Checkbox oszlop -->
            <ngx-datatable-column [width]="40" [sortable]="false" [canAutoResize]="false"
                                  [draggable]="false" [resizeable]="false">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn">
                <input type="checkbox" [checked]="allRowsSelected" (change)="selectFn(!allRowsSelected)" />
              </ng-template>
              <ng-template ngx-datatable-cell-template let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
                <input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
              </ng-template>
            </ngx-datatable-column>

            <!-- Dinamikus adatoszlopok -->
            <ngx-datatable-column *ngFor="let col of columns"
                                  [name]="columnLabel(col)"
                                  [prop]="col.Field"
                                  [width]="colWidth(col)"
                                  [sortable]="true">
              <ng-template ngx-datatable-cell-template let-value="value">
                <span [title]="value">{{ displayValue(value) }}</span>
              </ng-template>
            </ngx-datatable-column>

          </ngx-datatable>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- ═══ MODAL: Tábla-konfiguráció szerkesztése ═══════════════════════════════ -->
<ion-modal #metaModal class="nagy1">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="metaModal.dismiss()" style="background:white;border-radius:5px">Bezár</ion-button>
        </ion-buttons>
        <ion-title>{{ metaEditMode === 'add' ? 'Tábla hozzáadása' : 'Tábla szerkesztése' }}</ion-title>
        <ion-buttons slot="end">
          <ion-button [disabled]="metaForm.invalid" (click)="saveMeta()"
                      style="background:white;border-radius:5px" color="secondary">
            Mentés
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <form [formGroup]="metaForm">
        <ion-card>
          <ion-card-content>
            <!-- Táblanév selector az adatbázisból -->
            <ion-item lines="none" style="margin-bottom: 12px">
              <ion-label position="stacked">Tábla neve az adatbázisban *</ion-label>
              <ion-select interface="popover" placeholder="Válassz táblát…" formControlName="table_name">
                <ion-select-option *ngFor="let t of dbTablas" [value]="t.table_name">
                  {{ t.table_name }}{{ t.comment ? ' – ' + t.comment : '' }}
                </ion-select-option>
              </ion-select>
            </ion-item>
            <div *ngIf="metaForm.get('table_name')?.errors?.['pattern']" style="color:red;font-size:.8em;margin-bottom:8px">
              Érvénytelen táblanév (csak betűk, számok, aláhúzás).
            </div>

            <ion-input label="Megjelenítési neve *" label-placement="stacked" fill="outline"
                       formControlName="display_name" placeholder="pl. Tantárgyak"></ion-input>
            <br>
            <ion-input label="Intézmény szűrő mező neve" label-placement="stacked" fill="outline"
                       formControlName="intezmeny_field"
                       placeholder="pl. intezmeny (üresen hagyd, ha nincs)"></ion-input>
            <br>
            <ion-input label="Elsődleges kulcs mező neve *" label-placement="stacked" fill="outline"
                       formControlName="id_field" placeholder="id"></ion-input>
            <br>
            <ion-input label="Sorrend" label-placement="stacked" fill="outline" type="number"
                       formControlName="ordsz" placeholder="0"></ion-input>
            <br>
            <!-- Menü-kategória -->
            <ion-item lines="none" style="margin-bottom: 12px">
              <ion-label position="stacked">Admin menü-kategória</ion-label>
              <ion-select interface="popover" placeholder="Nincs hozzárendelve"
                          formControlName="menu_kategoria"
                          [value]="metaForm.get('menu_kategoria')?.value">
                <ion-select-option [value]="null">— Nincs —</ion-select-option>
                <ion-select-option *ngFor="let k of menuCategories" [value]="k.value">
                  {{ k.label }}
                </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-card-content>
        </ion-card>
      </form>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- ═══ MODAL: Sor szerkesztése ══════════════════════════════════════════════ -->
<ion-modal #rowModal class="nagy1">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="rowModal.dismiss()" style="background:white;border-radius:5px">Bezár</ion-button>
        </ion-buttons>
        <ion-title>{{ rowEditMode === 'add' ? 'Új sor' : 'Sor szerkesztése' }} – {{ activeMeta?.display_name }}</ion-title>
        <ion-buttons slot="end">
          <ion-button [disabled]="rowForm.invalid" (click)="saveRow()"
                      style="background:white;border-radius:5px" color="secondary">
            Mentés
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <form [formGroup]="rowForm">
        <ion-card>
          <ion-card-content>
            <ng-container *ngFor="let col of columns">
              <!-- Az auto_increment / elsődleges kulcs mező csak olvasható szerkesztéskor, hozzáadáskor rejtett -->
              <ng-container *ngIf="!(rowEditMode === 'add' && col.Extra === 'auto_increment')">
                <ion-input
                  [label]="columnLabel(col) + (col.Null === 'NO' && col.Extra !== 'auto_increment' ? ' *' : '')"
                  label-placement="stacked"
                  fill="outline"
                  [type]="inputType(col)"
                  [formControlName]="col.Field"
                  [readonly]="col.Extra === 'auto_increment' || (rowEditMode === 'edit' && col.Key === 'PRI')"
                  [placeholder]="col.Default ?? col.Type">
                </ion-input>
                <div *ngIf="rowForm.get(col.Field)?.invalid && rowForm.get(col.Field)?.touched"
                     style="color:red;font-size:.8em;margin-bottom: 4px">
                  Kötelező mező!
                </div>
                <br>
              </ng-container>
            </ng-container>
          </ion-card-content>
        </ion-card>
      </form>
    </ion-content>
  </ng-template>
</ion-modal>
